import { Quote, User } from "lucide-react";

/* Three slots, ready to populate. No stock faces and no invented quotes: a fabricated testimonial
   is the fastest way to lose a cold visitor who checks. */
const SLOTS = ["one", "two", "three"];

export const ProofSection = () => (
  <section id="about" data-testid="proof-section" className="scroll-mt-20 bg-background px-4 py-16 sm:px-6 sm:py-20">
    <div className="mx-auto max-w-6xl">
      <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-gold">From the field</p>
      <h2 className="mt-3 font-display text-3xl font-bold leading-tight text-royal-deep sm:text-4xl">
        Operators who run on Cornerstone Ops.
      </h2>
      <p className="mt-3 max-w-2xl text-sm text-muted-foreground sm:text-base">
        Cornerstone Ops runs Priority House Cleaning LLC on the Outer Banks every turnover day. As
        other operators come on board, their words go here — not stock photos and invented praise.
      </p>

      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {SLOTS.map((s) => (
          <div
            key={s}
            data-testid={`testimonial-slot-${s}`}
            className="rounded-2xl border border-dashed border-royal/25 bg-white p-6"
          >
            <Quote className="h-5 w-5 text-gold" />
            <p className="mt-4 text-sm italic text-muted-foreground">
              Customer testimonials coming soon
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary">
                <User className="h-4 w-4 text-royal/50" />
              </span>
              <div>
                <p className="text-sm font-semibold text-royal-deep/60">First name</p>
                <p className="text-[11px] text-muted-foreground">Company · Role</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
